import React from 'react';
import { ReactComponent } from 'Common/components/Icons/protective-gloves.svg';

const ProtectiveGloves = () => <ReactComponent className="MuiSvgIcon-root" />;

export default ProtectiveGloves;
